import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Poppins', sans-serif;
    background-color: #F0F4F8;
    color: #333;
    line-height: 1.6;
  }

  /* Main headers stand out */
  h1 {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 700;   /* strong */
    line-height: 1.2;
    letter-spacing: -0.5px;
  }

  /* Other headers */
  h2, h3, h4, h5, h6 {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 600;   /* slightly lighter */
    line-height: 1.3;
  }

  /* Ensure everything else inherits Poppins too */
  p, li, a, button, input, select, textarea, label {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 400;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;
